// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__OPOk1","title":"Images45_title__234Sr","images":"Images45_images__1iQRO"};